import { useSelector } from 'react-redux'

import { Permission, PermissionType, UserRole, UserType } from 'api/interfaces'
import { useGetCurrentUserAccessQuery } from 'api/rtkQueryApi/platform/organizationsApi'
import { RootState } from 'app/rootReducer'

export interface CampaignApprovalState {
  isEnabled: boolean
  canCreate: boolean
  canApprove: boolean
  canManageUsers: boolean
  userType: UserType | undefined
  userRoles: UserRole[]
}

export const useCampaignApproval = (): CampaignApprovalState => {
  const { currentOrganization, currentUser } = useSelector((state: RootState) => state.app)

  const isEnabled = currentOrganization?.permissions?.some((permission: Permission) => permission.permissionType === PermissionType.PlatformCampaignApprovalProcess) ?? false
  const currentUserAccessQuery = useGetCurrentUserAccessQuery(undefined, { skip: !isEnabled || !currentUser })

  const userType = currentUserAccessQuery.data?.userType ?? currentUser?.userType
  const userRoles = currentUserAccessQuery.data?.userRoles ?? currentUser?.userRoles ?? []

  if (!isEnabled) {
    return {
      isEnabled: false,
      canCreate: true,
      canApprove: true,
      canManageUsers: true,
      userType,
      userRoles
    }
  }

  const isPlatformAdmin = userType === UserType.PlatformAdmin

  return {
    isEnabled: true,
    canCreate: userRoles.includes(UserRole.Create),
    canApprove: userRoles.includes(UserRole.Approve),
    canManageUsers: isPlatformAdmin,
    userType,
    userRoles
  }
}
